export default "__VITE_ASSET__Cb5RHsLy__"